import React from "react";
import { RxChevronDown, RxChevronRight } from "react-icons/rx";
import { useDataMan } from "../../hooks/useDataMan";
import { useDataManRow } from "../../hooks/useDataManRow";
import { Button } from "@cmp-src/primitives/button";
export const DataManCollapsibleButton: React.FC = () => {
  const { openHierarchyItems, toggleHierarchyItem } = useDataMan();
  const { data } = useDataManRow();
  const isOpen = !!openHierarchyItems?.includes(data.id);
  return (
    <div>
      <Button
        variant={"ghost"}
        className={"p-1 border-0"}
        aria-label={isOpen ? "Collapse" : "Expand"}
        aria-expanded={isOpen}
        onClick={(event) => {
          event.stopPropagation();
          event.preventDefault();
          toggleHierarchyItem(data.id);
        }}
      >
        {isOpen ? (
          <RxChevronDown aria-hidden className="h-3 w-3 text-neutral-600" />
        ) : (
          <RxChevronRight aria-hidden className="h-3 w-3 text-neutral-600" />
        )}
      </Button>
    </div>
  );
};
